import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Configuraciones,
  ICliente,
  ICreateCliente,
  IListado,
  IQueryParam,
  IUpdateCliente,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class ClientesService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<ICliente>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/clientes`, { params });
  }

  public crear(dato: ICreateCliente): Observable<ICliente> {
    return this.http.post(`${api}/clientes`, dato);
  }

  public listarPorId(id: string): Observable<ICliente> {
    return this.http.get(`${api}/clientes/${id}`);
  }

  public editar(id: string, dato: IUpdateCliente): Observable<ICliente> {
    return this.http.put(`${api}/clientes/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/clientes/${id}`);
  }
}
